export const baseUrlPattern = '(https?:\\/\\/)?(([\\w-]+\\.)+[a-z]{2,}|(\\d{1,3}\\.){3}\\d{1,3})(:\\d+)?(\\/[\\w\\-._~+%@]*)*(\\?[\\w\\-._~+=&%;]*)?(#[\\w\\-._]*)?';
export const urlPattern = new RegExp(`^${baseUrlPattern}$`, 'i');
export const pathNamePattern = /^(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(#[-a-z\d_]*)?$/i;
export const isValidUrl = (url) => !!url && !!urlPattern.test(url);
export const containsUrlPattern = new RegExp(baseUrlPattern, 'gi');
